import { MemoriamDto } from '@careapp-group/ng-sdk';
import { CAAction, Memoriams } from '../actions';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';

export interface MemoriamStateInterface extends DataListState<MemoriamDto> {}

class MemoriamState extends ReducerStateFactory<MemoriamDto> {
  readonly initialState: MemoriamStateInterface = {
    ...INITIAL_DATA_LIST_STATE,
  };

  constructor(actions) {
    super(actions);
  }

  public reducer(state = this.initialState, action: CAAction): MemoriamStateInterface {
    switch (action.type) {
      case Memoriams.RESPONSE_SUCCESS_NO_MEMORIAM:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.id]: false,
          },
        };
      case Memoriams.REQUEST_REMOVE_MEMORIAM:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.memoriamId]: true,
          },
        };
      case Memoriams.REQUEST_COMPLETE_MEMORIAM:
      case Memoriams.REQUEST_BY_CUSTOMER_ID:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.id]: true,
          },
        };
      case Memoriams.RESPONSE_SUCCESS_REMOVE:
        const memoriamId = action.payload.memoriamId;
        const ids = [...state.ids].filter((id) => id !== memoriamId);
        const entities = ids.reduce(
          (prev, next) => ({ ...prev, [next]: state.entities[next] }),
          {}
        );
        const loadingEntities = {
          ...state.loadingEntities,
          [memoriamId]: false,
        };

        return {
          ...state,
          ids,
          entities,
          loadingEntities,
        };
      case Memoriams.RESPONSE_FAIL_REMOVE:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.memoriamId]: false,
          },
        };
      case Memoriams.RESPONSE_FAIL_BY_CUSTOMER_ID:
      case Memoriams.RESPONSE_SUCCESS_COMPLETE:
      case Memoriams.RESPONSE_FAIL_COMPLETE:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.id]: false,
          },
        };
      case Memoriams.RESPONSE_SUCCESS_BY_CUSTOMER_ID:
        const newState = {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.id]: false,
          },
        };
        // Trigger insertion of the entity into the store
        return super.reducer(
          newState,
          Memoriams.ResponseSuccessByIdAction(action.payload.memoriam)
        );
    }
    return <any>super.reducer(state, action);
  }
}

export const state = new MemoriamState(Memoriams);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
